import controller from 'core/controllerPlans'
import updateDOM from './updateDOM'
import once from 'utils/functional/once'
import 'bootstrap/js/src/modal'
import initDOM from './initDOM'
import config from './config'
import './styles.scss'

const registry = [once(initDOM), updateDOM]

controller(config, registry)
